/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ value: NonNullable<unknown> }} Statsactionspermessage3Inputs */

const en_statsactionspermessage3 = /** @type {(inputs: Statsactionspermessage3Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Avg. ${i?.value} per message`)
};

const de_statsactionspermessage3 = /** @type {(inputs: Statsactionspermessage3Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Ø ${i?.value} pro Nachricht`)
};

/**
* | output |
* | --- |
* | "Avg. {value} per message" |
*
* @param {Statsactionspermessage3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const statsactionspermessage3 = /** @type {((inputs: Statsactionspermessage3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Statsactionspermessage3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_statsactionspermessage3(inputs)
	return de_statsactionspermessage3(inputs)
});
export { statsactionspermessage3 as "statsActionsPerMessage" }